import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { STORY_RIBBONS_HEIGHT } from './constants'

function setStoryRibbonsHeightCSSVar(height: number) {
  document.documentElement?.style.setProperty(
    '--view-story-ribbon-height',
    `${height}px`,
  )
}

interface ToggleStoryRibbonsProps {
  isShown: boolean
}

let isStoryRibbonsOpen = true
const setters: Dispatch<SetStateAction<boolean>>[] = []

export const StoryRibbonsApi = {
  toggleStoryRibbons({ isShown }: ToggleStoryRibbonsProps) {
    setStoryRibbonsHeightCSSVar(isShown ? STORY_RIBBONS_HEIGHT : 0)
    isStoryRibbonsOpen = isShown
    setters.map(setter => setter(isShown))
  },
}

export function useIsStoryRibbonOpen() {
  const [open, setOpen] = useState(isStoryRibbonsOpen)

  useEffect(() => {
    setters.push(setOpen)

    return () => {
      const index = setters.findIndex(setter => setter === setOpen)
      if (index !== -1) {
        setters.splice(index, 1)
      }
    }
  }, [])

  return { open }
}
